import * as angular from 'angular';
import $ from 'jquery';
import {
    PreRequestResetUserPasswordController,
    PreResetUserPasswordController,
    PreVerifySystemUserController,
    PreVerifyUserController,
    RequestResetUserPasswordController,
    ResetUserPasswordController,
    VerifySystemUserController,
    VerifyUserController} from './user-controllers';

export default angular.module('dataforvalter.user', [])
    .controller('PreVerifyUserController', PreVerifyUserController)
    .controller('PreVerifySystemUserController', PreVerifySystemUserController)
    .controller('PreRequestResetUserPasswordController', PreRequestResetUserPasswordController)
    .controller('PreResetUserPasswordController', PreResetUserPasswordController)
    .controller('VerifyUserController', VerifyUserController)
    .controller('VerifySystemUserController', VerifySystemUserController)
    .controller('RequestResetUserPasswordController', RequestResetUserPasswordController)
    .controller('ResetUserPasswordController', ResetUserPasswordController)
    .directive('pwCheck', function(): any {
        return {
            require: 'ngModel',
            link(scope: angular.IScope, elem: JQLite, attrs: {pwCheck: string}, ctrl: angular.INgModelController) {
                const otherPassword = '#' + attrs.pwCheck;
                const otherPw = $(otherPassword);
                (ctrl.$validators as any).pwCheck = function() {
                    const val = elem.val();
                    const val2 = otherPw.val();
                    return val === val2;
                };
            }
        };
    })
    .name;
